import React from 'react';
import useDragScroll from '../../components/utils/useDragScroll'; // Hook personalizzato per lo scroll

const CategoryCarousel = ({
  items = [],
  categoryIcon,
  categoryTitle,
  renderCard,
  category
}) => {
  const { scrollRef } = useDragScroll(); // Utilizza sempre lo scrollRef; l'hook gestisce internamente il comportamento

  const categoryClasses = {
    flights: "flex-shrink-0 w-[95%] md:w-[40%] lg:max-w-[350px]", 
    trains:  "flex-shrink-0 w-[95%] md:w-[40%] lg:max-w-[500px]",
    rooms:   "flex-shrink-0 w-[95%] md:w-[40%] lg:max-w-[350px]",
  };

  return (
    <div className="w-full py-8 my-2 bg-smoky">
      <div className="flex items-center mb-4">
        <img 
          src={categoryIcon} 
          alt={`${categoryTitle} Icon`} 
          className="md:w-8 md:h-8 w-7 h-7 mr-2" 
        />
        <h2 className="lg:text-3xl text-2xl font-semibold uppercase font-heading mt-2">
          {categoryTitle}
        </h2>
      </div>

      <div 
        className="flex overflow-x-auto overflow-y-hidden py-2 space-x-4 
                   md:space-x-6 md:space-x-10 w-full lg:p-4 lg:space-x-20
                   bg-smoky custom-scrollbar"
        ref={scrollRef} // Sempre applicato: l'hook si occupa di abilitare il drag solo su desktop
      >
        {items.map(item => (
          <div key={item._id} className={categoryClasses[category] || "flex-shrink-0"}>
            {renderCard(item)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryCarousel;
